import i18next from "i18next";

export const getDefaultMessage = () => i18next.t("Trang Được hiển thị con số không tồn tại. một lúc sau đó lại Vui lòng thử.");
